var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"ModalFormGroup",attrs:{"id":"modal-form-group","title":_vm.$t('addGroup'),"size":"lg","static":"","centered":"","hide-footer":""},on:{"show":function($event){return _vm.resetData()},"hidden":function($event){return _vm.resetData()}}},[_c('FormGroup',{ref:"FormGroup",staticClass:"mb-0"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }